import React from 'react';
import { formatQccAmount } from '../../constants/qcc-balance-mock';
import type { QccBalanceRow } from '../../../hooks/useQccBalances';
import styles from './qcc-balance-rows.module.scss';

type QccBalanceRowsProps = {
  rows: QccBalanceRow[];
  loading?: boolean;
};

const QccBalanceRows: React.FC<QccBalanceRowsProps> = ({
  rows,
  loading = false,
}) => {
  return (
    <div className={styles.list} role="list">
      {rows.map(row => (
        <div key={row.id} className={styles.row} role="listitem">
          <img className={styles.icon} src={row.icon} alt="" />
          <span className={styles.name}>{row.name}:</span>
          <span className={styles.amount}>
            {loading ? '...' : formatQccAmount(row.amount)}
          </span>
        </div>
      ))}
    </div>
  );
};

QccBalanceRows.defaultProps = {
  loading: false,
};

export default QccBalanceRows;
